<template>
  <div class="instanceOpsLog-page">
    <Card shadow>
      <Row>
        <i-col span="18">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="6">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Card shadow>
        <div>
          <Row>
            <i-col span="24">
              <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
                <FormItem prop="name">
                  <i-input clearable placeholder="Content 内容" v-model="searchForm.name" style="min-width: 200px;" search
                           @on-enter="getOpsLog()"></i-input>
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getOpsLog()">搜索</Button>
                  <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
                </FormItem>
                <FormItem prop="date" style="float: right;text-align:right;margin-right:0;">
                  <DatePicker type="daterange" :value="dateValue" :options="dateOption" placement="bottom-end"
                              placeholder="Select date" @on-change="getOpsLog"></DatePicker>
                </FormItem>
              </Form>
            </i-col>
          </Row>
          <tables ref="opsLogTable" height="600" search-place="top" v-model="opsLogData" :columns="opsLogColumns"/>
          <Row style="margin: 10px;">
            <div style="float: right;">
              <page :total="count" :current="page" :page-size="size" @on-change="getOpsLog"></page>
            </div>
          </Row>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getOpsLogList} from '@/api/mysql'

export default {
  name: 'MySQLInstanceOpsLog',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      count: 1,
      size: 15,
      page: 1,
      dateValue: [new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      is_superuser: false,
      opsLogColumns: [
        {
          title: '时间',
          key: 'create_time',
          align: 'center',
          minWidth: 250,
          render: (h, params) => {
            return h('div', new Date(params.row.create_time).toLocaleString())
          }
        },
        { title: '内容', key: 'content', minWidth: 250 }
      ],
      opsLogData: []
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },
  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getOpsLog()
    },
    refresh () {
      this.getOpsLog()
    },
    getOpsLog (value = 1) {
      if (typeof value === 'number') {
        this.page = value
      } else {
        this.dateValue = value
      }
      let params = {
        instance_id: this.$route.query.id,
        page: this.page,
        size: this.size,
        create_time__gt: this.dateValue[0],
        create_time__lt: this.dateValue[1],
        content: this.searchForm.name
      }
      getOpsLogList(params).then(res => {
        this.opsLogData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    }
  },

  mounted: function () {
    this.getOpsLog()
  }
}
</script>
<style lang="less">
@media screen and (max-width:640px) {
  .instanceOpsLog-page {
    .ivu-table-wrapper {
      height: initial!important;
    }
    h1 {
      font-size: 1.5em;
    }
    .ivu-divider-horizontal {
      margin: 10px 0 15px;
    }
  }
}
</style>
